import { render, staticRenderFns } from "./Wenzhen.vue?vue&type=template&id=5ac6c0a8&scoped=true"
import script from "./Wenzhen.vue?vue&type=script&lang=js"
export * from "./Wenzhen.vue?vue&type=script&lang=js"
import style0 from "./Wenzhen.vue?vue&type=style&index=0&id=5ac6c0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac6c0a8",
  null
  
)

export default component.exports